import {QueryReturnValue} from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import {FetchBaseQueryError} from '@reduxjs/toolkit/query';

import {DOCUMENT_TAG} from 'app/documents/api';
import {sweetAPI} from 'app/store/sweet-api';
import {taskDispatcher} from 'app/subscriptions/taskDispatcher';
import {IMPORTDOC_API_URL} from 'app/urls';

import type {ImportableDocsContentType} from 'app/docimport/types';
import type {
  BasicFolderSerializedType,
  BasicTeamSerializedType,
  UserJobSerializedType,
} from 'sweet-types';

const DOCIMPORT_TAG = 'docimport';

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: [DOCIMPORT_TAG, DOCUMENT_TAG]})
  .injectEndpoints({
    endpoints: (build) => ({
      importDocument: build.mutation<
        {result: string},
        {
          key: string;
          target_content_type: ImportableDocsContentType;
          original_filename: string;
          teams: Array<BasicTeamSerializedType>;
          folders: Array<BasicFolderSerializedType>;
        }
      >({
        queryFn: (
          {key, target_content_type, original_filename, teams, folders},
          api,
          extraOptions,
          baseQuery
        ): Promise<
          QueryReturnValue<{result: string}, FetchBaseQueryError, any>
        > => {
          return api
            .dispatch(
              taskDispatcher(
                (
                  baseQuery({
                    url: IMPORTDOC_API_URL,
                    method: 'POST',
                    body: {
                      key,
                      target_content_type,
                      original_filename,
                      teams: teams.map((t) => t.url),
                      folders: folders.map((f) => f.url),
                    },
                  }) as Promise<
                    QueryReturnValue<
                      {job: UserJobSerializedType},
                      FetchBaseQueryError,
                      any
                    >
                  >
                ).then((response) => {
                  if (response.data) {
                    return response.data;
                  } else {
                    throw response.error;
                  }
                })
              )
            )
            .then(
              (job) => ({data: job}),
              () => Promise.reject("Couldn't import document.")
            );
        },
        invalidatesTags: () => [{type: DOCUMENT_TAG, id: 'list'}],
      }),
    }),
  });

export const {useImportDocumentMutation: useImportDocument} = extendedAPI;
